"use strict";
// Listens for mouse and keyboard events to determine the current input method.
//
// The `intent-mouse` class is added to the body when the mouse is used and removed when the keyboard is used.
// This will let you override styles for mouse users with CSS like this:
//
// ```css
// body.intent-mouse [role="button"]:focus,
// body.intent-mouse [role="tabpanel"][tabindex="0"]:focus,
// body.intent-mouse [type="checkbox"]:focus,
// body.intent-mouse a:focus,
// body.intent-mouse button:focus,
// body.intent-mouse summary:focus {
//   outline: none;
//   box-shadow: none;
// }
//
// body.intent-mouse details-dialog:focus {
//   outline: none;
// }
// ```
let lastActiveElement;
let isCurrentInputMouse = false;
function setClass() {
    lastActiveElement = document.activeElement;
    if (document.body) {
        document.body.classList.toggle("intent-mouse", isCurrentInputMouse);
    }
}
document.addEventListener("mousedown", () => {
    isCurrentInputMouse = true;
    if (lastActiveElement === document.activeElement) {
        setClass();
    }
}, { capture: true });
document.addEventListener("keydown", () => {
    isCurrentInputMouse = false;
}, { capture: true });
document.addEventListener("focusin", setClass, { capture: true });
